import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=1dfe97a2&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dfe97a2')) {
      api.createRecord('1dfe97a2', component.options)
    } else {
      api.reload('1dfe97a2', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=1dfe97a2&", function () {
      api.rerender('1dfe97a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/Register.vue"
export default component.exports